"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePersistedState = void 0;
const react_1 = require("react");
const usePersistedState = (key, defaultValue, storageType = 'localStorage', { serialize = JSON.stringify, unserialize = JSON.parse } = {
    serialize: JSON.stringify,
    unserialize: JSON.parse,
}) => {
    const storage = (0, react_1.useMemo)(() => (window === null || window === void 0 ? void 0 : window[storageType]) || window.localStorage, [storageType]);
    const initState = () => typeof defaultValue === 'function'
        ? defaultValue()
        : defaultValue;
    const [state, setState] = (0, react_1.useState)(() => {
        const item = storage.getItem(key);
        if (item) {
            return unserialize(item);
        }
        return initState();
    });
    (0, react_1.useDebugValue)(`${key}: ${serialize(state)}`);
    const prevKeyRef = (0, react_1.useRef)(key);
    (0, react_1.useEffect)(() => {
        const prevKey = prevKeyRef.current;
        if (prevKey !== key) {
            storage.removeItem(prevKey);
        }
        prevKeyRef.current = key;
    }, [key, storage]);
    (0, react_1.useEffect)(() => {
        storage.setItem(key, serialize(state));
    }, [key, serialize, state, storage]);
    const resetState = () => {
        storage.removeItem(key);
        setState(initState());
    };
    return [state, setState, resetState];
};
exports.usePersistedState = usePersistedState;
//# sourceMappingURL=index.js.map